export default "__VITE_PUBLIC_ASSET__13eae898__"